export enum EPromotionStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	EXPIRED = 'expired',
	DEPLETED = 'depleted',
}

export const PromotionStatusMap: Record<EPromotionStatus, string> = {
	[EPromotionStatus.ACTIVE]: 'Aktywny',
	[EPromotionStatus.INACTIVE]: 'Nieaktywny',
	[EPromotionStatus.EXPIRED]: 'Wygasły',
	[EPromotionStatus.DEPLETED]: 'Wyczerpany',
}

export const PromotionStatuses = generateSelectOptions(EPromotionStatus, PromotionStatusMap)

export enum EPromotionType {
	FIXED = 'cart_fixed_discount',
	PERCENTAGE = 'cart_percentage_discount',
}

export const PromotionTypeMap: Record<EPromotionType, string> = {
	[EPromotionType.FIXED]: 'Kwotowy',
	[EPromotionType.PERCENTAGE]: 'Procentowy',
}

export const PromotionTypes = generateSelectOptions(EPromotionType, PromotionTypeMap)

export enum EPromotionTabs {
	GENERAL = 'general',
	RULES = 'rules',
	LIMITS = 'limits',
	USAGE = 'usage',
}

export enum EPromotionLimit {
	NO_LIMIT = 'no_limit',
	LIMIT = 'limit',
}

export const PromotionLimitMap: Record<EPromotionLimit, string> = {
	[EPromotionLimit.NO_LIMIT]: 'Bez limitu',
	[EPromotionLimit.LIMIT]: 'Limit',
}

export const PromotionLimits = generateSelectOptions(EPromotionLimit, PromotionLimitMap)

export enum EPromotionActionType {
	FIXED = 'cart_fixed_discount',
	PERCENTAGE = 'cart_percentage_discount',
}

export const PromotionActionTypeMap: Record<EPromotionActionType, string> = {
	[EPromotionActionType.FIXED]: 'Kwotowy',
	[EPromotionActionType.PERCENTAGE]: 'Procentowy',
}

export const PromotionActionTypes = generateSelectOptions(EPromotionActionType, PromotionActionTypeMap)

export enum EPromotionRuleType {
	CART_QUANTITY = 'cart_quantity',
	CART_MINIMUM_VALUE = 'cart_minimum_value',
	CART_MAXIMUM_VALUE = 'cart_maximum_value',
	LOYALTY_POINTS = 'loyalty_points',
	SELECTED_CLIENTS = 'selected_clients',
	DIETARY_PRODUCT = 'dietary_product',
}

export const PromotionRuleTypeMap: Record<EPromotionRuleType, string> = {
	[EPromotionRuleType.CART_QUANTITY]: 'Minimalna ilość produktów',
	[EPromotionRuleType.CART_MINIMUM_VALUE]: 'Miminalna wartość koszyka',
	[EPromotionRuleType.CART_MAXIMUM_VALUE]: 'Maksymalna wartość koszyka',
	[EPromotionRuleType.LOYALTY_POINTS]: 'Punkty lojalnościowe',
	[EPromotionRuleType.SELECTED_CLIENTS]: 'Wybrani klienci',
	[EPromotionRuleType.DIETARY_PRODUCT]: 'Wybrane produkty',
}

export const PromotionRuleTypes = generateSelectOptions(EPromotionRuleType, PromotionRuleTypeMap)
